import * as Yup from 'yup';
import { DatePreference, SeasonName } from './types';
import { formats } from './weddingDateFormat';

export const validationSchema = Yup.object().shape(
  {
    hideCountdown: Yup.bool(),
    hideDate: Yup.bool(),
    date: Yup.string()
      .trim()
      .matches(/\d{4}-\d{2}-\d{2}/)
      .when('preference', {
        is: val => val === DatePreference.Exact,
        then: Yup.string().required('Please enter a date.'),
      }),
    rangeStart: Yup.string()
      .trim()
      .matches(/\d{4}-\d{2}-\d{2}/)
      .nullable()
      .when('preference', {
        is: val => val === DatePreference.Range,
        then: Yup.string().required('Please enter a start date.'),
      }),
    rangeEnd: Yup.string()
      .trim()
      .matches(/\d{4}-\d{2}-\d{2}/)
      .nullable()
      .when('preference', {
        is: val => val === DatePreference.Range,
        then: Yup.string().required('Please enter an end date.'),
      }),
    season: Yup.string()
      .ensure()
      .when('preference', {
        is: val => val === DatePreference.Season,
        then: Yup.string().required('Please enter a season.'),
      })
      .when('year', {
        is: val => val !== '',
        then: Yup.string()
          .oneOf(Object.values(SeasonName))
          .required(),
      }),
    year: Yup.string()
      .ensure()
      .when('preference', {
        is: val => val === DatePreference.Season,
        then: Yup.string().required('Please enter a year.'),
      })
      .when('season', {
        is: val => val !== '',
        then: Yup.string()
          .trim()
          .matches(/\d{4}/)
          .required(),
      }),
    preference: Yup.string()
      .oneOf(Object.values(DatePreference))
      .required(),
    format: Yup.string().when('preference', {
      is: val => val === DatePreference.Exact || val === DatePreference.Range,
      then: Yup.string()
        .oneOf(formats)
        .required(),
    }),
  },
  [['season', 'year']]
);
